module.exports = __webpack_public_path__ + "static/photo10-c19f0ae44aecca28452eeeea5621d235.jpg";